module.exports = {
  id: 36,
  name: 'Tuck Jumps',
  categories: ['cardio', 'strength', 'legs', 'explosiveness'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Power',
  points: 23,
  instructions:
    'Tuck jumps are super explosive! Jump up and bring your knees to your chest! This builds incredible leg power and core strength!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to tuck jump like a pro? Let us build incredible leg power and explosiveness!',
    },
    {
      time: 3,
      text: 'Stand with feet shoulder-width apart, arms at your sides!',
    },
    {
      time: 6,
      text: 'Keep your core engaged and get ready to explode!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Bend your knees and swing your arms back!',
    },
    // SET 1 - 8 tuck jumps
    {
      time: 12,
      text: 'Perfect position! Feet shoulder-width apart, ready to explode!',
    },
    {
      time: 15,
      text: 'Number 1! Bend your knees and swing your arms back!',
    },
    {
      time: 18,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 21,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 24,
      text: 'Number 2! Bend your knees and swing your arms back!',
    },
    {
      time: 27,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 30,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 33,
      text: 'Number 3! Bend your knees and swing your arms back!',
    },
    {
      time: 36,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 39,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 42,
      text: 'Number 4! Bend your knees and swing your arms back!',
    },
    {
      time: 45,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 48,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 51,
      text: 'Number 5! Bend your knees and swing your arms back!',
    },
    {
      time: 54,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 57,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 60,
      text: 'Number 6! Bend your knees and swing your arms back!',
    },
    {
      time: 63,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 66,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 69,
      text: 'Number 7! Bend your knees and swing your arms back!',
    },
    {
      time: 72,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 75,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 78,
      text: 'Number 8! Bend your knees and swing your arms back!',
    },
    {
      time: 81,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 84,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 87,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 1 - 30 seconds
    {
      time: 90,
      text: 'Take a deep breath in and out, you are building incredible power!',
    },
    {
      time: 93,
      text: 'Shake out your legs and feet, get ready for round two!',
    },
    {
      time: 96,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 99,
      text: 'Remember to bend your knees and explode up!',
    },
    {
      time: 102,
      text: '3, 2, 1, START! Bend your knees and swing your arms back!',
    },
    // SET 2 - 8 tuck jumps
    {
      time: 105,
      text: 'Perfect position! Feet shoulder-width apart, ready to explode!',
    },
    {
      time: 108,
      text: 'Number 1! Bend your knees and swing your arms back!',
    },
    {
      time: 111,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 114,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 117,
      text: 'Number 2! Bend your knees and swing your arms back!',
    },
    {
      time: 120,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 123,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 126,
      text: 'Number 3! Bend your knees and swing your arms back!',
    },
    {
      time: 129,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 132,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 135,
      text: 'Number 4! Bend your knees and swing your arms back!',
    },
    {
      time: 138,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 141,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 144,
      text: 'Number 5! Bend your knees and swing your arms back!',
    },
    {
      time: 147,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 150,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 153,
      text: 'Number 6! Bend your knees and swing your arms back!',
    },
    {
      time: 156,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 159,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 162,
      text: 'Number 7! Bend your knees and swing your arms back!',
    },
    {
      time: 165,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 168,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 171,
      text: 'Number 8! Bend your knees and swing your arms back!',
    },
    {
      time: 174,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 177,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 180,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 30 seconds
    {
      time: 183,
      text: 'Take a deep breath in and out, you are building incredible power!',
    },
    {
      time: 186,
      text: 'Shake out your legs and feet, get ready for the final round!',
    },
    {
      time: 189,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 192,
      text: 'Remember to bend your knees and explode up!',
    },
    {
      time: 195,
      text: '3, 2, 1, START! Bend your knees and swing your arms back!',
    },
    // SET 3 - 8 tuck jumps
    {
      time: 198,
      text: 'Perfect position! Feet shoulder-width apart, ready to explode!',
    },
    {
      time: 201,
      text: 'Number 1! Bend your knees and swing your arms back!',
    },
    {
      time: 204,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 207,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 210,
      text: 'Number 2! Bend your knees and swing your arms back!',
    },
    {
      time: 213,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 216,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 219,
      text: 'Number 3! Bend your knees and swing your arms back!',
    },
    {
      time: 222,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 225,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 228,
      text: 'Number 4! Bend your knees and swing your arms back!',
    },
    {
      time: 231,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 234,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 237,
      text: 'Number 5! Bend your knees and swing your arms back!',
    },
    {
      time: 240,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 243,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 246,
      text: 'Number 6! Bend your knees and swing your arms back!',
    },
    {
      time: 249,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 252,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 255,
      text: 'Number 7! Bend your knees and swing your arms back!',
    },
    {
      time: 258,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 261,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 264,
      text: 'Number 8! Bend your knees and swing your arms back!',
    },
    {
      time: 267,
      text: 'Explode up and bring your knees to your chest!',
    },
    {
      time: 270,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 273,
      text: 'Incredible work! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 276,
      text: 'Amazing work! You did 24 tuck jumps and built incredible power!',
    },
    {
      time: 279,
      text: 'You are getting super explosive and powerful! You are a tuck jump master!',
    },
    {
      time: 282,
      text: 'Great job, power champion! You are building incredible skills!',
    },
  ],
};
